import { css } from '@emotion/css';

import { SMALL_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const buttonGroupClassName = css({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
});

export const spacingClassName = css({
  marginTop: Spacing.SM,
  [SMALL_DEVICE_MQ]: {
    marginTop: Spacing.MD,
  },
});

export const uploaderClassName = css({
  height: 251, // keep height same as GIF carousel
});
